import React from 'react';
import './Pagination.css';

const Pagination = ({ 
  totalItems, 
  itemsPerPage, 
  currentPage, 
  onPageChange
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;
  const startRecord = totalItems === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
  const endRecord = Math.min(currentPage * itemsPerPage, totalItems);

  const handlePrev = () => {
    if (currentPage > 1) onPageChange(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) onPageChange(currentPage + 1);
  };

  return (
    <div className="custom-pagination-wrapper">
      <div className="custom-pagination-info">
        Showing <b>{startRecord}</b> to <b>{endRecord}</b> of <b>{totalItems}</b> entries
      </div>

      <div className="custom-pagination-buttons">
        <button 
          className="custom-pagination-btn" 
          onClick={handlePrev} 
          disabled={currentPage === 1}
        >
          Previous
        </button>
        
        <span className="custom-pagination-current-page">
          Page {currentPage} of {totalPages}
        </span>
        
        <button 
          className="custom-pagination-btn" 
          onClick={handleNext} 
          disabled={currentPage === totalPages || totalPages === 0}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Pagination;